<script>
import BaseContainer from '@/components/default/views/shared/BaseContainer.vue'
import BaseStatusIcon from '@/components/default/views/shared/BaseStatusIcon'
import { authError } from '@/helpers/auth'
import { mapGetters } from 'vuex'

export default {
	name: 'EnrollmentList',
	components: {
		BaseContainer,
		BaseStatusIcon
	},
	props: ['enrollmentList'],
	data: () => ({
		activeEnrollmentId: null
	}),
	methods: {
		openEnrollment: function (enrollmentId) {
			this.activeEnrollmentId = enrollmentId
			this.$store.dispatch('loadEnrollment', enrollmentId)
				.then((res) => {
					this.$router.push({	name: 'enrollment' })
				}).catch((error) => {
					if (authError(error)) return
					new Noty({
						text: this.$t('commonMsg.couldNotGetEnrollmentDocs') + ` ${response.data.id}`,
						layout: 'bottomCenter',
						timeout: 2500
					}).show()
				})
		}
	},
	computed: {
		...mapGetters(['employee']),
		enrollmentListTitle: function () {
			return ((this.enrollmentList.length > 0) ? this.$t('dashboard.recentEnrollments') : this.$t('dashboard.noEnrollment'))
		},
		employeeName: function () {
			return this.employee ? this.employee.name : ''
		}
	}
}
</script>

<template>
	<div class="enrollment-list" >
		<base-container modifiers="default-width inner column-layout align-center space-evenly">
			<h1 class="enrollment-list__title">
				{{ enrollmentListTitle }}
			</h1>
			<base-card modifiers="box-shadow" class="enrollment-list__card" :header="false" v-for="enrollment in enrollmentList"
				:key="enrollment.id" @click.native="openEnrollment(enrollment.id)"
				:class="{ 'enrollment-list__loading' : (activeEnrollmentId === enrollment.id) }">
				<div slot="content" class="enrollment-list__overlay" v-show="(activeEnrollmentId === enrollment.id)">
					<div class="enrollment-list__spinner">
						<font-awesome-icon :icon="['fas', 'spinner']" class="fa-spin" spin />
					</div>
				</div>
				<div slot="content" class="enrollment-list__content">
					<div class="enrollment-list__information">
						<div class="enrollment-list__information--row">
							<base-status-icon :status="enrollment.status"/>
							<h2 class="enrollment-list__name">{{ enrollment.name }}</h2>
						</div>
						<div class="enrollment-list__date">
							{{ enrollment.created | moment("YYYY-MM-DD") }}
						</div>
						<div>
							{{$t('dashboard.submitBy') + employeeName }}
						</div>
					</div>
					<div class="enrollment-list__actions">
						<div><font-awesome-icon :icon="['fas', 'chevron-right']" /></div>
					</div>
				</div>
			</base-card>
		</base-container>
	</div>
</template>

<style lang="scss">
	.enrollment-list {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		width: 100%;
		background-color: var(--dashboard-bg);
		color: var(--text-colour);
		padding: 1rem 2rem;
		min-height: 75vh;
		@media (max-width: 600px) {
			padding: 1rem 0.75rem;
		}
		&__title {
			width: 100%;
			text-align: left;
			font-size: 1.5rem;
			font-weight: bold;
			margin-bottom: 0.5rem;
		}
		&__card {
			cursor: pointer;
		}
		&__loading {
			height: 130px;
			justify-content: center;
			position: relative;
		}
		&__overlay {
			position: absolute;
			background-color: #EEE;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			z-index: 10;
			opacity: 0.6;
			transition: .5s ease;
			@media (max-width: 550px) {
				opacity: 0.7;
			}
		}
		&__spinner {
			height: 100%;
			width: 100%;
			text-align: center;
			padding-top: 2rem;
			font-size: 3.25rem;
			max-height: 100px;
			transition: .5s ease;
		}
		&__content {
			display: flex;
			width: 100%;
			height: 80px;
			justify-content: space-between;
			position: relative;
		}
		&__information {
			display: flex;
			flex-direction: column;
			max-width: 70%;
			flex: 0 0 70%;
			&--row {
				display: flex;
				align-items: center;
				padding-bottom: 0.5rem;
			}
		}
		&__name {
			display: inline-block;
			vertical-align: middle;
			font-size: 1.25rem;
			font-weight: bold;
			padding: 0rem 0.5rem 0rem 1rem;
		}
		&__date {
			padding-bottom: 0.25rem;
			font-weight: bold;
		}
		&__actions {
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
		}
	}
</style>
